"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function backgroundColor(status, theme) {
  switch (status) {
    case 'inactive':
      return theme.ui.background;

    case 'normal':
      return '#FFFFFF';

    case 'selected':
      return theme.brand.lightest;

    default:
      break;
  }
}

function borderColor(status, theme) {
  switch (status) {
    case 'inactive':
      return theme.ui.outline;

    case 'normal':
      return theme.ui.outline;

    case 'selected':
      return theme.brand.secondary;

    default:
      break;
  }
}

function iconColor(status, theme) {
  switch (status) {
    case 'inactive':
      return theme.ui.outline;

    case 'normal':
      return theme.ui.interactive;

    case 'selected':
      return theme.brand.primary;

    default:
      break;
  }
}

var RadioButton = _styledComponents.default.label.withConfig({
  displayName: "RadioButton"
})(["font-family:", ";font-size:1.6rem;position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center;width:140px;height:140px;padding:43px auto auto 27px;cursor:pointer;margin-right:1.3vw;background-color:", ";border:1px solid;border-color:", ";box-sizing:border-box;border-radius:5px;color:", ";&::after{content:'", "';display:block;position:absolute;bottom:10px;left:50%;transform:translateX(-50%);white-space:nowrap;}svg{width:96px;height:54px;margin-bottom:10px;path{fill:", ";stroke:", ";}}input{display:block;position:absolute;left:0;right:0;top:0;bottom:0;width:100%;height:100%;opacity:0;cursor:pointer;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.font;
}, function (_ref2) {
  var mode = _ref2.mode,
      theme = _ref2.theme;
  return backgroundColor(mode, theme);
}, function (_ref3) {
  var mode = _ref3.mode,
      theme = _ref3.theme;
  return borderColor(mode, theme);
}, function (_ref4) {
  var mode = _ref4.mode,
      theme = _ref4.theme;
  return iconColor(mode, theme);
}, function (_ref5) {
  var label = _ref5.label;
  return label;
}, function (_ref6) {
  var mode = _ref6.mode,
      theme = _ref6.theme;
  return iconColor(mode, theme);
}, function (_ref7) {
  var mode = _ref7.mode,
      theme = _ref7.theme;
  return iconColor(mode, theme);
});

RadioButton.displayName = 'RadioButton';
var ImageSelectBox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref8, ref) {
  var selected = _ref8.selected,
      label = _ref8.label,
      value = _ref8.value,
      icon = _ref8.icon,
      onChange = _ref8.onChange,
      name = _ref8.name,
      otherProps = _objectWithoutProperties(_ref8, ["selected", "label", "value", "icon", "onChange", "name"]);

  var handleChange = function handleChange(e) {
    e.persist();
    onChange({
      name: e.target.name,
      value: e.target.value
    });
  };

  var mode = 'normal';
  if (selected === value) mode = 'selected';else if (selected) mode = 'inactive';
  return /*#__PURE__*/_react.default.createElement(RadioButton, _extends({
    mode: mode,
    label: label
  }, otherProps), icon, /*#__PURE__*/_react.default.createElement("input", {
    ref: ref,
    type: "radio",
    checked: selected === value,
    value: value,
    onChange: handleChange,
    name: name
  }));
});
ImageSelectBox.displayName = 'ImageSelectBox';
ImageSelectBox.defaultProps = {
  label: 'means',
  onChange: function onChange() {},
  name: 'radios',
  otherProps: {},
  selected: ''
};
ImageSelectBox.propTypes = {
  selected: _propTypes.string,
  label: _propTypes.string,
  value: _propTypes.string.isRequired,
  icon: _propTypes.node,
  onChange: _propTypes.func,
  mode: _propTypes.string,
  name: _propTypes.string,
  otherProps: _propTypes.object
};
var _default = ImageSelectBox;
exports.default = _default;